module.exports = __webpack_public_path__ + "img/21.ed413ce5.jpg";